import SportBadge from './SportBadge';

export default SportBadge;
export { getSportIconSrc } from './SportBadge';
export type { SportBadgeProps } from './types';
